/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkspaceRequest } from '../../models/update-workspace-request';
import { UpdateWorkspaceResponse } from '../../models/update-workspace-response';

export interface UpdateWorkspace$Params {

/**
 * Workspace ID
 */
  workspaceId: number;
  
    /**
     * Workspace update data
     */
    body?: UpdateWorkspaceRequest
}

export function updateWorkspace(http: HttpClient, rootUrl: string, params: UpdateWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, updateWorkspace.PATH, 'patch');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateWorkspaceResponse>;
    })
  );
}

updateWorkspace.PATH = '/workspaces/{workspaceId}';
